import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WiredSensorRow } from 'z3k-settings/climatic/digital-sensors/ui/wired-sensor-row';
export function SensorsTable({ sensors, predicate, onDelete }) {
    return (_jsx(_Fragment, { children: sensors.map((setting, i) => {
            if (!predicate(setting)) {
                return null;
            }
            return (_jsx(WiredSensorRow, { setting: setting, onDelete: onDelete }, setting.sensor_id));
        }) }));
}
